import React from "react";
import Bucket from "../component/Bucket";
import { useDispatch, useSelector } from "react-redux";
import ResultLottery from "../component/buylotteryComponent/ResultLottery";
import SearchNumber from "../component/buylotteryComponent/SearchNumber";
import TicketCard from "../component/buylotteryComponent/TicketCard";
import {
  getLotteryFromSearch,
  pushLotteryFromSearch,
} from "../features/lotteryReducer";
import { addLotteryHoldNumber } from "../features/lotteryInvoice";
import PreviousBar from "../component/PreviousBar";
import { useNavigate } from "react-router-dom";
import Loading from "../component/Loading";
import NumSet from "../component/buylotteryComponent/NumSet";

const Buylottery = () => {
  const navigate = useNavigate();
  const lotteryFromSearch = useSelector(
    (state) => state.lottery.lotteryFromSearch
  );
  const [Number, setNumber] = React.useState(["", "", "", "", "", ""]);
  const lastTimer = useSelector((state) => state.invoice.lastTimer);
  const inputRef = React.useRef([]);
  // console.log(Number);
  const dispatch = useDispatch();
  const [countLotteryPickup, setCountLotteryPickup] = React.useState(
    JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId")))
  );

  React.useEffect(() => {
    dispatch(getLotteryFromSearch());
  }, []);
  // console.log(lotteryFromSearch);
  const onChange = (e) => {
    if (
      e.target.value.length < 1 &&
      e.target.id !== "0" &&
      e.target.value.match(/^[0-9]*$/)
    ) {
      // console.log("0");
      inputRef.current[parseInt(e.target.id) - 1].focus();
    }

    if (e.target.value.length <= 1 && e.target.value.match(/^[0-9]*$/)) {
      // console.log("1");
      let numbers = [...Number];
      let num = e.target.value;
      numbers[e.target.id] = num;
      setNumber(numbers);
    }
    if (
      e.target.value.length === 1 &&
      e.target.id != Number.length - 1 &&
      e.target.value.match(/^[0-9]*$/)
    ) {
      // console.log(Number.length)
      // console.log("2");
      inputRef.current[parseInt(e.target.id) + 1].focus();
    }
  };

  const onClickSearch = () => {
    dispatch(getLotteryFromSearch(Number));
  };

  const onPickUp = (newData) => {
    if (!localStorage.getItem(localStorage.getItem("lotteryId"))) {
      localStorage.setItem(
        localStorage.getItem("lotteryId"),
        JSON.stringify([newData])
      );
    } else {
      let temp = JSON.parse(
        localStorage.getItem(localStorage.getItem("lotteryId"))
      );
      temp.push(newData);
      localStorage.setItem(
        localStorage.getItem("lotteryId"),
        JSON.stringify(temp)
      );
    }
    let tempCheck = {
      betNumber: newData.lotteryNumber,
      betType: newData.lotteryType,
      lotteryRound: newData.lotteryRound,
    };
    if (!localStorage.getItem(`check_${localStorage.getItem("lotteryId")}`)) {
      localStorage.setItem(
        localStorage.getItem("lotteryId"),
        JSON.stringify([tempCheck])
      );
    } else {
      let preCheck = JSON.parse(
        localStorage.getItem(`check_${localStorage.getItem("lotteryId")}`)
      );
      preCheck.push(tempCheck);
      localStorage.setItem(
        `check_${localStorage.getItem("lotteryId")}`,
        JSON.stringify(preCheck)
      );
    }
    setCountLotteryPickup(
      JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId")))
    );
  };

  const onPickOff = (lottoryNumber) => {
    let Tickets = JSON.parse(
      localStorage.getItem(localStorage.getItem("lotteryId"))
    );
    const newTickets = Tickets.filter(
      (ticket) => ticket.lotteryNumber !== lottoryNumber
    );

    localStorage.setItem(
      localStorage.getItem("lotteryId"),
      JSON.stringify(newTickets)
    );

    let TicketsCheck = JSON.parse(
      localStorage.getItem(`check_${localStorage.getItem("lotteryId")}`)
    );

    const newTicketsCheck = TicketsCheck.filter(
      (ticket) => ticket.betNumber !== lottoryNumber
    );

    localStorage.setItem(
      `check_${localStorage.getItem("lotteryId")}`,
      JSON.stringify(newTicketsCheck)
    );

    setCountLotteryPickup(
      JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId")))
    );
  };

  const randomNumber = async () => {
    setNumber(["", "", "", "", "", ""]);
    dispatch(getLotteryFromSearch());
  };

  const clearNumber = () => {
    setNumber(["", "", "", "", "", ""]);
  };

  const startTimer = async () => {
    const statusHolding = await dispatch(addLotteryHoldNumber());
    if (statusHolding) {
      navigate("/checkout");
    } else {
      alert("ระบบเกิดข้อผิดพลาดกรุณาติดต่อพนักงาน Error: 3o4r3");
    }
  };

  const newLotterySearch = async () => {
    await dispatch(pushLotteryFromSearch(Number, lotteryFromSearch));
  };
  console.log("lotteryFromSearch :", lotteryFromSearch);
  return (
    <div className="bg-[#ffffff] text-center font-bold min-h-screen static md:pb-10">
      <PreviousBar name={localStorage.getItem("lotteryName")} />
      <SearchNumber
        Number={Number}
        onChange={onChange}
        onSearch={onClickSearch}
        refer={inputRef}
        randomNumber={randomNumber}
        clearNumber={clearNumber}
      />
      <p className="text-base py-1 text-[#b3853e]">เลขชุด</p>

      {/* <NumSet /> */}
      <p className="text-base py-1 text-[#b3853e]">ผลการค้นหา</p>
      {/* <ResultLottery /> */}
      <Bucket
        countLotteryPickup={countLotteryPickup || 0}
        startTimer={startTimer}
      />
      {lotteryFromSearch ? (
        <div>
          <TicketCard
            dataLotteryFromSeach={lotteryFromSearch}
            onPickUp={onPickUp}
            onPickOff={onPickOff}
            newLotterySearch={newLotterySearch}
          />
          {/* <button
          className="rounded-md text-sm bg-[#FFD700] text-[#b3853e] w-full py-1"
          onClick={() => dispatch(pushLotteryFromSearch(Number, lotteryFromSearch))}
          >
            ดูรายการเพิ่มเติม
          </button> */}
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default Buylottery;
